import { Referrals } from 'components/Referrals';
import { Page } from 'layouts/Page';
import { FC } from 'react';

export const ReferralsPage: FC = () => {
	return (
		<Page title="Referrals – EAS Control Center">
			<Referrals />
		</Page>
	);
};
